import { Container } from 'react-bootstrap';
import '../../styles/dashboardSkeleton.css';

// [span-class, body-height] – mirrors actual bento layout
const BENTO = [
  ['span-8',  240],
  ['span-4',  160],
  ['span-4 compact', 100],
  ['span-4 compact', 160],
  ['span-4 compact', 140],
  ['span-4 compact', 180],
  ['span-4 compact', 120],
  ['span-4 compact', 140],
  ['span-12', 190],
];

export default function DashboardSkeleton() {
  return (
    <Container fluid className="px-4 py-3" aria-busy="true" aria-label="Carregando dashboard">
      <div className="sk-head">
        <div>
          <div className="sk-block sk-eyebrow" />
          <div className="sk-block sk-title" />
          <div className="sk-block sk-sub" />
        </div>
        <div className="sk-block sk-filterbar" />
      </div>

      <div className="grid-stats mb-4">
        {[0, 1, 2, 3].map(i => (
          <div className="sk-metric" key={i}>
            <div className="sk-block sk-metric-ic" />
            <div className="sk-block sk-metric-label" />
            <div className="sk-block sk-metric-value" />
            <div className="sk-block sk-metric-foot" />
          </div>
        ))}
      </div>

      <div className="bento">
        {BENTO.map(([span, h], i) => (
          <div className={`sk-chart ${span}`} key={i}>
            <div className="sk-block sk-chart-title" />
            <div className="sk-block sk-chart-note" />
            <div className="sk-block sk-chart-body" style={{ height: h }} />
          </div>
        ))}
      </div>
    </Container>
  );
}
